import { DateTime } from "luxon";

import i18n from "../i18n";

//date is an ISO string - can be straight from the API
//format is a luxon DateTime format - https://github.com/moment/luxon/blob/master/docs/formatting.md#presets
//e.g DateTime.DATE_SHORT = 10/14/1983
//e.g DateTime.DATETIME_SHORT = 10/14/1983 10:30 AM


// We need to always use this function to display the dates so the timezone is handled correctly
export default function formatDateTime(date, format, nullValue = "") {
  if (!date) return nullValue;

  // Follow the selected UI language for date wording/ordering, but keep
  // Europe/London as the business timezone regardless of language.
  const locale = i18n.language?.startsWith("pl") ? "pl" : "en-gb";

  return DateTime.fromISO(date, { zone: 'utc' }) //Parse date as UTC
    .setZone("Europe/London") //Convert to local timezone
    .setLocale(locale) //Set locale to match the UI language
    .toLocaleString(format) //Format date
}